import { SiteFooter } from "@motleyhand/design"
import { Link } from "@tanstack/react-router"

export default function Footer() {
  return (
    <SiteFooter>
      <Link
        to="/legal/$slug"
        params={{ slug: "terms" }}
        className="transition-colors hover:text-foreground"
      >
        Terms
      </Link>
      <Link
        to="/legal/$slug"
        params={{ slug: "privacy" }}
        className="transition-colors hover:text-foreground"
      >
        Privacy
      </Link>
      <Link to="/contact" className="transition-colors hover:text-foreground">
        Contact
      </Link>
    </SiteFooter>
  )
}
